import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const ciscoSecureCloudAnalytics = defineConnector({
  identifier: "ciscoSecureCloudAnalytics",
  name: "Cisco Secure Cloud Analytics",
  tagLine: "Cloud-native network detection and response",
  logo,
  protocol: "http",
  tags: ["security", "observability"],
  defaultUrlPattern: ({ portalUrl }) =>
    urlToPattern(
      `${portalUrl || "https://company.obsrvbl.com"}/api`,
      "https://[^/]*\\.obsrvbl\\.com/api/.*"
    ),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `ApiKey ${app.config.apiUser}:${app.secret.apiKey}`,
      },
    ]),
  steps: [
    {
      title: "Create an API key in Secure Cloud Analytics",
      items: [
        {
          kind: "markdown",
          content:
            "In your Secure Cloud Analytics portal, open your user settings and generate an API key. Copy the key and note the user account it belongs to.",
        },
      ],
    },
    {
      title: "Enter your Secure Cloud Analytics details",
      items: [
        {
          kind: "baseUrl",
          label: "Portal URL",
          placeholder: "https://company.obsrvbl.com",
          required: true,
          helperText: "Enter the same portal URL you sign into.",
          target: { kind: "configuration", field: "portalUrl" },
        },
        {
          kind: "input",
          label: "API user",
          required: true,
          helperText: "Paste the user account the API key belongs to.",
          target: { kind: "configuration", field: "apiUser" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          helperText: "Paste the API key from your user settings.",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ portalUrl }) =>
      `${portalUrl || "https://company.obsrvbl.com"}/api/v3/alerts/alert/`,
  },
});
